module.exports = __webpack_public_path__ + "static/img/logof.f66444b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/pt/logof.png
// module id = ebND
// module chunks = 1